module.exports = __webpack_public_path__ + "img/esquemaB.8749d027.svg";